<template>
	<div class="panel ">
		<div class="panel-hdr ">
			<h2>
				<span class="icon-stack fs-xxl mr-2">
					<i class="base base-7 icon-stack-3x opacity-100 color-primary-500"></i>
					<i class="base base-7 icon-stack-2x opacity-100 color-primary-400"></i>
					<i class="fal  fa-sync icon-stack-1x opacity-100 color-white fa-spin"></i>
				</span>
				{{__t('REGISTRATION')}}
			</h2>
		</div>
		<div class="panel-container show">
			<div class="panel-content mb-0">
				<div class="user_auth">
					<form class="user" autocomplete="off">
						<div class="form-group">
							<b-form-input
								:state="username_state"
								id="input-live-feedback_username"
								v-model="user_form.username"
								class="form-control form-control-use"
								:placeholder="__t('USER_LOGIN')">
							</b-form-input>

							<b-form-invalid-feedback id="input-live-feedback">
                                {{__t('MIN_3_SYMBOLS')}}
							</b-form-invalid-feedback>
						</div>

						<div class="phone form-group">
							<the-mask
								:mask="['+## (###) ###-##-##','+## (###) ###-##-##']"
								ref="phone_inp"
								class="form-control form-control-user "
								v-bind:class="{ 'is-invalid': !is_phone_ok,'fill': is_phone_ok }"
								id="my-phone"
								type="text"
								:placeholder="__t('USER_PHONE')"
								v-model="user_form.phone"
								:masked="false"/>
						</div>

						<div class="form-group">
							<b-form-input
								:state="userpass_state"
								id="user_pass_register"
								:type=field_type.pass
								v-model="user_form.password" class="form-control form-control-user"
								:placeholder="__t('PASSWORD')"
                            ></b-form-input>

							<b-form-invalid-feedback id="user_pass">
                                {{__t('MIN_6_SYMBOLS')}}
							</b-form-invalid-feedback>

						</div>

						<div class="form-group">
							<b-button class="btn btn-success btn-user btn-block" v-on:click="make_register">
                                {{__t('REGISTRATION')}}
							</b-button>
						</div>

					</form>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
    /*
import DisableAutocomplete from 'vue-disable-autocomplete';

Vue.use(DisableAutocomplete);
*/
export default {
	name: "register",
    props : {
	    'cur_user' : {
	        type : String,
            default : "",
        },
        register_type : {
	        type : String,
            default : "standart",
        },

        auth_server_params : {
            type : Object,
        },
    },
	data() {
		return {
			is_auth: false,
			is_input_ok: false,
			field_type: {
				pass: "password",
			},

			user_form: {
				username: "",
				password: "",
				phone: "",
			}
		}
	},

	created() {
	    if(this.cur_user.length > 0) {
            this.user_form.username = this.cur_user;
        }

        console.log(this.auth_server_params);
	},

	methods: {

		async make_register() {
			_core.showloading();
			let send_data = this.user_form;
			send_data.auth_params = this.auth_server_params;

            let url = '/internal/user/register/' + this.register_type;

            console.log(this.auth_server_params);
            if(this.auth_server_params.hasOwnProperty("new_auth")) {
                url = '/web/oauth/'+ this.register_type +'/redirect'
            }

			await api.post(url, send_data).then(({data}) => {
				_core.hideloading();
				if (data.status === "operation_success") {
					if(data.data.hasOwnProperty("redirect")) {
						window.location.href = data.data.redirect;
					}
				}
				else {
					EventBus.$emit('show_toast', {err: this.__t('ERR'), type: "danger", title: "Нет"})
				}
			}).catch(({response}) => {
                _core.hideloading();
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
		},
	},

	computed: {

		is_phone_ok () {
			return this.user_form.phone.length == 12;
		},

		is_disabled() {
			return this.username_state && this.userpass_state && this.is_phone_ok;
		},

		username_state() {
			return this.user_form.username.length > 2;
		},

		userpass_state() {
			return this.user_form.password.length > 5;
		}
	}
}
</script>

<style scoped>

</style>
